import FingerprintJS from '@fingerprintjs/fingerprintjs';

const FINGERPRINT_KEY = 'fingerprint';

let fingerprintPromise: Promise<string> | null = null;

const canUseStorage = () => typeof window !== 'undefined' && typeof localStorage !== 'undefined';

const getStoredFingerprint = () => {
  if (!canUseStorage()) {
    return null;
  }

  return localStorage.getItem(FINGERPRINT_KEY);
};

export function getDeviceFingerprint(): string {
  return getStoredFingerprint() ?? '';
}

const createFallbackFingerprint = () => window.crypto?.randomUUID?.();

export async function ensureDeviceFingerprint(): Promise<string> {
  if (!canUseStorage()) {
    return '';
  }

  const storedFingerprint = getStoredFingerprint();

  if (storedFingerprint) {
    return storedFingerprint;
  }

  if (!fingerprintPromise) {
    fingerprintPromise = FingerprintJS.load()
      .then(agent => agent.get())
      .then(result => {
        localStorage.setItem(FINGERPRINT_KEY, result.visitorId);
        return result.visitorId;
      })
      .catch(() => {
        const fallbackFingerprint = createFallbackFingerprint();
        localStorage.setItem(FINGERPRINT_KEY, fallbackFingerprint);
        return fallbackFingerprint;
      })
      .finally(() => {
        fingerprintPromise = null;
      });
  }

  return fingerprintPromise;
}
